import React from "react";
import useUniqueId from "./useUniqueId";
import { Form } from "react-bootstrap";
import classNames from "classnames";

interface ToggleProps {
    isChecked: boolean;
    isDisabled?: boolean;
    onChange(isChecked: boolean): void;
    className?: string;
    label?: string;
}

const Toggle: React.FC<ToggleProps> = props => {

    const id = useUniqueId();

    return <Form.Switch
        id={`toggle${id}`}
        className={classNames("d-inline-block", props.className)}
        checked={props.isChecked ?? false}
        disabled={props.isDisabled}
        onChange={ev => props.onChange(ev.target.checked)}
        label={props.label}
    />;
};

export default React.memo(Toggle);